import { BaseService } from "@/shared/services";

class UserService extends BaseService {
  endpoint = "users";
}

export default new UserService();
